import React from 'react';
import PropTypes from 'prop-types';

import SimpleModal from './SimpleModal';

const ModalPwdResetEmailSent = ({ open, ctaAction }) => (
  <SimpleModal
    open={open}
    title="Check your email"
    body="We’ve sent you an email with instructions to reset your password."
    ctaText="Okay, got it"
    ctaAction={ctaAction}
    testId="modalPwdResetEmailSent"
  />
);

ModalPwdResetEmailSent.defaultProps = {
  open: false,
};

ModalPwdResetEmailSent.propTypes = {
  open: PropTypes.bool,
  ctaAction: PropTypes.func.isRequired,
};

export default ModalPwdResetEmailSent;
